import { render } from "./QuickActionDialog.vue?vue&type=template&id=1a37c812"
import script from "./QuickActionDialog.vue?vue&type=script&lang=js"
export * from "./QuickActionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__